import { OC_PLUS_LOGO } from './ocplus.js'

export const ACCOUNT_SIDEBAR_LINKS = [
    {
        id: 'orders',
        label: 'nav.menu_orders',
        url: '/account/orders',
        icon: 'far fa-archive fa-fw',
        props: {
            isActive: '/account/orders',
        },
    },
    {
        id: 'invoices',
        label: 'nav.menu_invoices',
        url: '/account/invoices',
        icon: 'far fa-receipt fa-fw',
        props: {
            isActive: '/account/invoices',
        },
    },
    {
        id: 'brands',
        label: 'nav.menu_brands',
        url: '/account/brands',
        icon: 'far fa-store-alt fa-fw',
        props: {
            isActive: '/account/brands',
        },
    },
    {
        id: 'favorites',
        label: 'nav.menu_favorites',
        url: '/account/favorites',
        icon: 'far fa-heart fa-fw',
        props: {
            isActive: '/account/favorites',
        },
    },
    {
        id: 'oc-plus',
        label: OC_PLUS_LOGO.normal.dark,
        url: '/account/plus',
        icon: 'far fa-plus fa-fw',
        props: {
            isActive: '/account/plus',
            useHtml: true,
        },
    },
    {
        id: 'inbox',
        label: 'nav.menu_inbox',
        url: '/account/inbox',
        icon: 'far fa-envelope fa-fw',
        props: {
            isActive: '/account/inbox',
        },
    },
    {
        id: 'edit',
        label: 'nav.menu_account_information',
        url: '/account/edit',
        icon: 'far fa-user-friends fa-fw',
        props: {
            isActive: '/account/edit',
            isHiddenFor: ['supplier'],
        },
    },
    {
        id: 'email-settings',
        label: 'nav.mail_settings',
        url: '/email-settings',
        icon: 'far fa-mailbox fa-fw',
        props: {
            isHiddenFor: ['supplier'],
        },
    },
    {
        id: 'channels',
        label: 'nav.menu_pos_ecom_integrations',
        url: '/account/channels',
        icon: 'far fa-object-group fa-fw',
        props: {
            isHiddenFor: ['supplier'],
            isActive: '/account/channels',
        },
    },
    {
        id: 'logout',
        label: 'nav.menu_logout',
        url: '/auth/logout',
        icon: 'far fa-power-off fa-fw',
        props: {
            isDirect: true,
        },
    },
]
